import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 路由级加载占位：懒加载页面挂载前与数据路由初始加载期间统一展示，
 * 避免布局跳动与空白帧。
 */
export function RouteLoading() {
    return (_jsx("main", { className: "route-loading", "aria-live": "polite", children: "\u9875\u9762\u52A0\u8F7D\u4E2D\u2026" }));
}
